import e from "../../utils/classNames.js";
import t from "./PillsItem.js";
import n from "./ScrollablePills.js";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/pills/Pills.tsx
var i = (t) => {
	let { className: i, variant: a = "default", overflow: o = "visible", previousButtonLabel: s = "Show previous pills", nextButtonLabel: c = "Show next pills", justified: l = !1, wordWrap: u = !1, iconOnly: d = !1, children: f, ...p } = t, m = a === "stacked" || a === "stacked-decent", h = a === "filled" || a === "filled-condensed", g = o === "scroll-buttons" && !m, _ = l && !m && !g, v = /* @__PURE__ */ r("ul", {
		...p,
		className: e("nav nav-pills", h && "nav-pills-filled", a === "filled-condensed" && "nav-pills-filled-condensed", m && "nav-stacked", a === "stacked-decent" && "nav-pills-stacked-decent", _ && "nav-justified", _ && u && "nav-justified-word-wrap", d && "text-size-18", i),
		children: f
	});
	return g ? /* @__PURE__ */ r(n, {
		...p,
		className: e("nav nav-pills", h && "nav-pills-filled", a === "filled-condensed" && "nav-pills-filled-condensed", d && "text-size-18", i),
		filled: h,
		previousButtonLabel: s,
		nextButtonLabel: c,
		children: f
	}) : v;
};
i.Item = t;
//#endregion
export { t as PillsItem, i as default };

//# sourceMappingURL=Pills.js.map